export default __webpack_public_path__ + "static/media/Frame.a34ed493.png";